export const SAVE_FCM_TOKEN = "users/customer/tokens/update";
